// Author LiangGangQiang
// Date 2021-12-08 14:56:39

import * as model from "@/model/sithMes/prd/SithMesPrdPpHeaderInfoModifyModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpHeaderInfoModify(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
